import React, { useState, useEffect } from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {update_company} from '../../../reducers/companyReducer'
import { Spinner} from 'react-bootstrap'
import { validate_canada_zip, validate_us_zip } from '../../../validations/GenralValidations'
import { set_loading_false, set_loading_true } from '../../../reducers/loadingReducer'
import userService from '../../../services/user'
import { update_user } from '../../../reducers/userReducer'
import { Formik, Form } from "formik";
import FormikTextInput from '../../ReusableComponents/FormikTextInput'
import FormikDropDown from '../../ReusableComponents/FormikDropDown'
import { create_company_profile } from '../../../validations/company'

const ManageCompany = () => {
    const dispatch = useDispatch()
    const company = useSelector( ({company}) => company )
    const general = useSelector( ({general}) => general)  
    const user = useSelector( ({user}) => user )

    const [countries, set_countries] = useState([])
    const [cities, set_cities] = useState([])
    const [provinces, set_provinces] = useState([])
    const [zip_error, set_zip_error] = useState(false);
    const [address_error, set_address_error] = useState(false);
    const validate_zip = (zip, country) => {
        return (country.name === 'USA'
                           ? !validate_us_zip(zip)
                           : !validate_canada_zip(zip) )
    }

    const validate_address = (country, province, city) => {
        const country_id = general.countries.find(c => Number(c.id) === Number(country.id)).id
        const province_id = general.provinces.find(c => Number(c.id) === Number(province.id)).id
        const province_country_id = general.provinces.find(c => Number(c.id) === Number(province.id)).country.id
        const city_province_id = general.cities.find(c => Number(c.id) === Number(city.id)).province.id
        if(country_id === province_country_id && province_id === city_province_id){
            set_address_error(0)
            return true
        }
        set_address_error(1)
        return false
    }
    
    const [img, set_img] = useState(null);

    useEffect(() =>{
        
        if(general.length!==0 && company){

            const countryArray = general.countries.map(pos => {
                return {value:pos.id,label:pos.name}
            })
            set_countries(countryArray)

            const cityArray = general.cities.map(pos => {
                return {value:pos.id,label:pos.name, province: pos.province}
            })
            set_cities(cityArray)

            const provinceArray = general.provinces.map(pos => {
                return {value:pos.id,label:pos.name, country: pos.country}
            })
            set_provinces(provinceArray)
        }
        
    },[general,company])

    const handle_file_select = (e) => {
        set_img(e.target.files[0]);
      };

    if(company){

        return (
            <div className='logged-in-container'>
            <div className='company-edit-form' >            
                <p className="font-weight-bold text-secondary h5 mb-4 mt-4">Manage your company</p>

                <div>
                <img 
                    className='profile-pic'
                    alt='Rapihire Profile img.'
                    src={user.profile_image ? user.profile_image : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARkAAAC0CAMAAACXO6ihAAAAYFBMVEXR1dr////N09fS09j///3U1NrT1Nv//v/O1Nj7+/z39/jN0dfQ0dfa297u7/DW2Nzj5+nm6Orw7/He4eTo7vH5/v7r6u7k5Onv8/XZ2d7p6enz+Prb4ePw7/LW19jU2t2fgRK2AAAFqElEQVR4nO2d65aqMAyFWwoIlIvIcXS8jO//lke8zFGPqG0DgQ3fmr+zbPcKTZOmqRATExMTExMTExMTExMTQ0Kf/iYuhKEQnqeLqirLPC/LKhMe95j6gVLFPN/KW7YrxT0qdjxR5XEthu/7t9rE1ZjtJgjUbi2b+DPiFUeVcaMu0pf7cVpNoA5/mmU5sxij1Sj19U6Xo9XMxyeNt3vxHd1IUwTcI+2YdPOBLjV5yj3UblGJ9N+rciIrCuFF3APuCi/5UJYL23IkIYPa+p9ajLxuABfcg+4CvTCzmDPLCt5svLmNMMd1qcSWJlSZlTA1X9B+KlSf7GMarGaFbDXp+51vszIy4x5+ixQza2WOxLgbG527CHNchWHzWcpFmBrUOCoqXZVBjaM8a8f0C+hKs3MWRs6559AKntP6eyaB3NNoJ5d9ATI3bB8Y3PCN6LidPVMN4hGdacLqOTmiMhTCQOawDiTKIDqnSlL4phhPGf01KdPA4uOjlJcAxgcLkyODZrinQY8mcdpSHrgnQo52D7RBlRGTMk3QCDMpMykzKUOmDOB+hkaYGfc0WmBSpgkarx1zT4Meoj0wYERJpEzCPY8WoIkoEXN6OUkWAlAZbVeG9ghiOQTB2W2tDGA1BE2GHLHGMyJRBrAizUtJtnqAtfZ5QqLMOueeCDWJT5Mgh4sPSOogLsyhvieSOogLa6QaGrUnVCaGUsbqgkoDSyhlCEr0/imDtM58cNP2c7C+JsoVGEoZXREqkyApIwpCZaC8thA0xTMnsOIDHdMpg1Vh7zV3UzEmQ/LaIqLJdZ7gngsxdCElWt0rVcmVlCWWaxKCLKYsuGdCDU2CHG43I1zv3f7jAOWZTtCcHWBtZs7ob4Lq+g2YY7qg9o7abDO4ReaMSt3WGqj0wwMrp8AyB1amcFKm5B5+iyinkBvwTPsXt5BbAVaIXHEKuRMVco+/RVyyntg9wFxC7op78K2SOoTceAHTLcr+eAUvyL5D2V8/QIwlb/HedpJuArDc9R7bDFYO7ZlqbKNK7nG3T2DXOg67a+eFnUVYGQfI+98rNp3AMuCQ6Qa9NbWa0bT3jwxjhP1YhBH1pUoDq1mPYfW9opLPlcGqsXqHWhmYzKiUMUlhjctmTBriIh+m/I9RYDkuZUxS5dgpqweMlOEebKd42/eC/AJXS/QKo0w58gncf6QmVRHYhwYPhAbCwGeA7zAqggUtJ3qO0eEK1kWDNxgpM6rwwOgmGGCfoiZCZVYtAl0EcYfpA1cjyQKLWhkjYeQc/nzySmR47r8YzRJsXJQ2mmj7x1AYueEecUdo8zpG7iF3g83l7XGsNFZ1InN8aaLD0qJa2h+BNNnSxmQketGrSEvbmwe+TATshi9Iv50avs6qFDRMKPbSpUHa8X+TDO+TCsJoTvEWz7pIAyjDUaqkusqe4xyyBIG2fIn9GbM6++lhlO0pNbf11E3kAYCbiryKrCXEDRsx8J2fUpXJOa0By1IN2W50RfSe1TNmQ+28HShv15K9XInn0RBdeJq1aC+/2qzSoRmOd+hAl5M2wwrCdUHZqPOdNtVgtPG61KUmqQbSnbxjXWq2/Q81tUk9KyXrot/a6FY2vJ+R9/iL0l046hf0NCEaKNKe2lbEWR+zfqp0ythRcPz9vHfLzWlnx63MKfves52fx+SRntGfB9PCUP3wrrx3+HJWqbAfOT+HNhgtkfcjd0P6mAERyQ//QhyqHn1JN2Ts31NPhZF+xvtB9dViZC0Nq9UYFvZ2C+eRXbrhnv0rYr7vSX1zT/41e67mABHRy9DtwbUK2/es6ogZ210O6uNqamY8dflBH/e+j8QcXVBDRVEp1DYVw6aG8qmU9uC4T0f5vE6LdC+M+bUKHrpv0U369FuLdP90zxA80wnR8RpsehWSj64vYYaUrwW2SueVWQNZZmyb8f0F12dSCfuP2I0AAAAASUVORK5CYII='}
                />
                
                <br /><br/>
                <input
                    onChange={handle_file_select}
                    type="file"
                    accept=".jpg, .jpeg, .png, .webp"
                />
                <br /><br/>
                </div>


            <Formik
                initialValues={{
                    name: company.name,
                    business_number: company.business_number,
                    address: company.address,
                    zip_code: company.zip_code,
                    city: company.city,
                    province: company.province,
                    country: company.country,
                    contact_name: company.contact_name || '',
                    contact_email: company.contact_email || '',
                    contact_phone: company.contact_phone || '',
                }}
                    validationSchema={create_company_profile}

                    onSubmit={async (values, {setSubmitting, resetForm})=>{
                        // resetForm();
                        setSubmitting(false);
                        set_zip_error(
                            values.country.name === 'USA'
                              ? !validate_us_zip(values.zip_code)
                              : !validate_canada_zip(values.zip_code),
                        );
                        const payload = {
                            id:company.id,
                            name:values.name,
                            business_number: values.business_number,
                            address:values.address,
                            zip_code:values.zip_code,
                            city_id:values.city.id,
                            country_id:values.country.id,
                            province_id:values.province.id,
                            contact_name:values.contact_name || 'Not provided',
                            contact_email:values.contact_email || user.email,
                            contact_phone:values.contact_phone
                        }

                        if (!validate_address(values.country, values.province, values.city)){
                            return
                        }

                        if ( ((values.country.name === 'USA' && validate_us_zip(values.zip_code)) 
                                ||
                            (values.country.name === 'Canada' && validate_canada_zip(values.zip_code))) 
                            ) {
                                if(img){
                                    const formData = new FormData();
                                    formData.append("file", img);
                                    dispatch(set_loading_true());
                                    userService
                                        .update_profile_image(formData)
                                        .then((data) => {
                                            dispatch(update_user({}));
                                            dispatch(update_company(payload));
                                    })
                                        .catch((err) => dispatch(set_loading_false()));
                                }else {
                                    dispatch(update_company(payload));
                                }
                        }
                        else {
                            console.log('invalid');
                        }
                    }}

                >
                {props => (
                    <Form>
                        
                        <div>
                            <FormikTextInput label='Company' name='name' placeholder={'Company name'}  />
                            <FormikTextInput label='Busines Number' name='business_number' placeholder={'Business number'}  />
                        </div>

                        <div>
                            <FormikDropDown 
                                label='Address'                 
                                options={countries}
                                name='country'
                                placeholder={'Country'}
                                value={countries.find(pos => pos.value === props.values.country?.id)}
                            />
                            <FormikDropDown
                                options={provinces.filter(province =>  (province.country.id) === (props.values.country?.id) )}
                                name='province'
                                placeholder={'Province'}
                                value={provinces.find(pos => pos.value === props.values.province?.id)}
                            />
                            <FormikDropDown
                                options={cities.filter(city =>  (city.province.id) === (props.values.province?.id) )}
                                name='city'
                                placeholder={'City'}
                                value={cities.find(pos => pos.value === props.values.city?.id)}

                            />
                            <div className='d-flex justify-content-between'>
                                <FormikTextInput style={{width:'150%'}} name='address' placeholder='Address'/>
                                <FormikTextInput  name='zip_code' placeholder='ZIP/Postal'/>
                            </div>
                        { zip_error && validate_zip(props.values.zip_code, props.values.country) && <p className='invalid-feedback text-right'>Invalid ZIP for {props.values.country.name}</p>}
                        { address_error && <p className='invalid-feedback text-right'>Please check Country, Province and City </p>}

                        </div> 

                        <div>
                            <FormikTextInput label='Contact' name='contact_name' placeholder='Contact Name'  />
                            <FormikTextInput name='contact_email' placeholder='Contact Email'  />
                            <FormikTextInput label='Phone Number' name='contact_phone' placeholder='Company Phone'  />
                        </div>

                        <div className='text-center'>
                            <button className="btn btn-primary w-50 mt-4" type='submit'>{props.isSubmitting ? 'Loading...' : 'Confirm'}</button>  
                        </div>  

                    </Form>
                )}
                </Formik>

            </div>
            </div>
        )}

        return  (<div style={{textAlign:'center', paddingTop:'100px'}}>
        <Spinner animation="border" /> 
        </div>)
}

export default ManageCompany